// Svenska sidor för felskrivna adresser och oväntade fel, i stället för routerns engelska standardtexter.
// Ritas inne i närmaste skal, så att menyn finns kvar när det går.
import { type ErrorComponentProps, Link, useParams } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { usePageTitle } from "../lib/title.ts";

/** Länk tillbaka: till projektet eller organisationen man är i, annars till startsidan. */
function BackLink() {
  const { orgId, projectId } = useParams({ strict: false }) as { orgId?: string; projectId?: string };
  if (orgId && projectId)
    return (
      <Link className="btn btn-primary" to={`/o/${orgId}/p/${projectId}`}>
        Till projektets översikt
      </Link>
    );
  if (orgId)
    return (
      <Link className="btn btn-primary" to={`/o/${orgId}`}>
        Till projekten
      </Link>
    );
  return (
    <Link className="btn btn-primary" to="/">
      Till startsidan
    </Link>
  );
}

/** Inne i projektskalet finns redan ett main-element; annars blir sidan själv huvudinnehållet. */
function Frame({ children }: { children: ReactNode }) {
  const { projectId } = useParams({ strict: false }) as { projectId?: string };
  if (projectId) return <div className="page">{children}</div>;
  return (
    <main id="main" className="page" tabIndex={-1}>
      {children}
    </main>
  );
}

export function NotFoundPage() {
  usePageTitle("Sidan finns inte");
  return (
    <Frame>
      <div className="empty card">
        <h1>Sidan finns inte</h1>
        <p>Adressen kan vara fel. Eller så har sidan flyttats eller tagits bort.</p>
        <BackLink />
      </div>
    </Frame>
  );
}

export function ErrorPage({ reset }: ErrorComponentProps) {
  usePageTitle("Något gick fel");
  return (
    <Frame>
      <div className="empty card" role="alert">
        <h1>Något gick fel</h1>
        <p>Sidan kunde inte visas. Försök igen, och hör av dig till oss om felet finns kvar.</p>
        <div className="row">
          <button type="button" className="btn" onClick={reset}>
            Försök igen
          </button>
          <BackLink />
        </div>
      </div>
    </Frame>
  );
}
